// Returns coefficients for particle-in-a-box states
// Assumes linear spaced input data
export const project_onto_pib_states = function(points, kn, tol) {
  let nmax = 50;

  let n = points.length;
  let xs = points.map( p => { return p.x } );
  let ys = points.map( p => { return p.y } );

  let a = xs[n-1] - xs[0];
  let dx = xs[1] - xs[0];

  let coeffs = []
  let i, k;

  let compute_inner_product = function(bra, ket) {
    let out = 0.0;
    let j;
    for (j = 0; j < n; ++j) {
      let g = (j==0 || j==n-1) ? 1 : 2;
      out += g * bra[j] * ket[j];
    }
    return out * 0.5 * dx;
  }

  let eigenket = function(xs, n) {
    let j = 0;
    let nx = xs.length;

    out = []

    for (j = 0; j < nx; ++j) {
      out.append(Math.sqrt(2 / a) * Math.sin( n * kn * xs[j]))
    }

    return out
  }

  let remaining_norm = compute_inner_product(ys, ys);

  for (i = 0; i < nmax; ++i) {
    let co = 0.0;

    for (k = 0; k < n; ++k) {
      let x = xs[k]
      let psix = ys[k]
      let phix = Math.sqrt(2 / a ) * Math.sin((i+1) * kn * x);

      let g = (k==0 || k==n-1) ? 1 : 2;
      co += g * psix * phix;
    }
    co *= 0.5 * dx;

    coeffs.push(co);

    for (k = 0; k < n; ++k) {
      ys[k] -= co * Math.sqrt(2/a) * Math.sin((i+1) * kn * xs[k]);
    }
    let nrm = compute_inner_product(ys, ys);
    if (nrm < tol) { break; }
  }

  return coeffs;
}
